/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class GroupService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get the name of the group
   *
   * LWM2M path: /1025/{groupId}/0
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return
   */
  getName(
    /*
     * Group id
     */
    groupId: number,
  ): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getNameCall(groupId));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/0
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return call options
   */
  getNameCall(
    /*
     * Group id
     */
    groupId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getName };

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Write group name
   *
   * LWM2M path: /1025/{groupId}/0
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param name input
   * @return
   */
  putName(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    name: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putNameCall(groupId, name));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/0
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param name input
   * @return call options
   */
  putNameCall(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    name: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putName };

    callOptions.body = name;

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Update password
   *
   * LWM2M path: /1025/{groupId}/2
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param password input
   * @return
   */
  changePassword(
    /*
     * Group id
     */
    groupId: number,

    /*
     *
     */
    password: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.changePasswordCall(groupId, password),
    );
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/2
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param password input
   * @return call options
   */
  changePasswordCall(
    /*
     * Group id
     */
    groupId: number,

    /*
     *
     */
    password: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.changePassword };

    callOptions.body = password;

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Change password using bytes data
   *
   * LWM2M path: /1025/{groupId}/2
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param password input
   * @return
   */
  changePasswordKey(
    /*
     * Group id
     */
    groupId: number,

    /*
     *
     */
    password: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.changePasswordKeyCall(groupId, password),
    );
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/2
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param password input
   * @return call options
   */
  changePasswordKeyCall(
    /*
     * Group id
     */
    groupId: number,

    /*
     *
     */
    password: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.changePasswordKey };

    callOptions.body = password;

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Get the maximum session lifetime
   *
   * LWM2M path: /1025/{groupId}/4
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return
   */
  getSessionLifetime(
    /*
     * Group id
     */
    groupId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getSessionLifetimeCall(groupId));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/4
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return call options
   */
  getSessionLifetimeCall(
    /*
     * Group id
     */
    groupId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getSessionLifetime };

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Write session lifetime in configuration
   *
   * LWM2M path: /1025/{groupId}/4
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param value input
   * @return
   */
  putSessionLifetime(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putSessionLifetimeCall(groupId, value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/4
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param value input
   * @return call options
   */
  putSessionLifetimeCall(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putSessionLifetime };

    callOptions.body = value;

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Get group alias
   *
   * LWM2M path: /1025/{groupId}/5
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return
   */
  getAlias(
    /*
     * Group id
     */
    groupId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getAliasCall(groupId));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/5
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return call options
   */
  getAliasCall(
    /*
     * Group id
     */
    groupId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getAlias };

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Write group alias in configuration
   *
   * LWM2M path: /1025/{groupId}/5
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param value input
   * @return
   */
  putAlias(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putAliasCall(groupId, value));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/5
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @param value input
   * @return call options
   */
  putAliasCall(
    /*
     * Group id to return
     */
    groupId: number,

    /*
     *
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putAlias };

    callOptions.body = value;

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }

  /**
   * Create group
   *
   * LWM2M path: /1025/{groupId}/65535
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return
   */
  create(
    /*
     * Group id
     */
    groupId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.createCall(groupId));
  }

  /**
   *
   *
   * LWM2M path: /1025/{groupId}/65535
   *
   * @tapVersion(">=1.0")
   * @param groupId input
   * @return call options
   */
  createCall(
    /*
     * Group id
     */
    groupId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.create };

    callOptions.pathParameters = {
      groupId: groupId,
    };

    return callOptions;
  }
}
